"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var ButtonWidgetStyles_1 = require("../styles/ButtonWidgetStyles");
var ButtonBase_1 = require("./Button/ButtonBase");
var DynamicThemeComponent_1 = require("./DynamicThemeComponent");
var TabStyles_1 = require("../styles/TabStyles");
var Declarative_1 = require("../utils/Declarative");
var delayStyle = {
    backgroundColor: TabStyles_1.TabStyles.Colors.L8,
    borderColor: TabStyles_1.TabStyles.Colors.L8,
    color: TabStyles_1.TabStyles.Colors.White
};
var AutoResetButton = /** @class */ (function (_super) {
    tslib_1.__extends(AutoResetButton, _super);
    function AutoResetButton(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClick = function (e) {
            if (!!_this.state.label) {
                return;
            }
            _this.setState({ label: _this.props.delayLabel });
            window.setTimeout(_this.handleReset, _this.getDelayOrDefault());
            _this.props.handleClick(e);
        };
        _this.handleReset = function () {
            _this.setState({ label: undefined });
            _this.props.handleReset();
        };
        _this.state = { label: undefined };
        return _this;
    }
    AutoResetButton.prototype.getDelayOrDefault = function () {
        return this.props.delay !== undefined ? this.props.delay : 5000;
    };
    AutoResetButton.prototype.render = function () {
        var buttonStyle = ButtonWidgetStyles_1.getButtonStyle(this.props.buttonType);
        // need to add the delayStyle to each style to make it have priority
        if (!!this.state.label) {
            buttonStyle.base = tslib_1.__assign({}, buttonStyle.base, delayStyle);
            buttonStyle.interactive.disabled = tslib_1.__assign({}, buttonStyle.interactive.disabled, delayStyle);
        }
        var buttonBaseProps = {
            disabled: this.props.disabled || !!this.state.label,
            handleClick: this.handleClick,
            interactiveStyle: buttonStyle.interactive,
            style: tslib_1.__assign({}, buttonStyle.base, this.props.style),
            testId: Declarative_1.testId(this.props.testId, 'Button'),
            title: this.props.title
        };
        return (React.createElement(ButtonBase_1.ButtonBase, tslib_1.__assign({}, buttonBaseProps),
            this.state.label || this.props.label,
            this.props.children));
    };
    return AutoResetButton;
}(DynamicThemeComponent_1.DynamicThemeComponent));
exports.AutoResetButton = AutoResetButton;
//# sourceMappingURL=AutoResetButtonWidget.js.map